export const MIN_LNG = -180 as const;
export const MAX_LNG = 180 as const;
export const MIN_LAT = -90 as const;
export const MAX_LAT = 90 as const;

/**
 * Validate latitude and longitude
 *
 * @param latitude The latitude to validate. A number between -90 and 90.
 * @param longitude The longitude to validate. A number between -180 and 180.
 * @returns true if the latitude and longitude are valid, false otherwise
 */
export function validateLatitudeAndLongitude(latitude: number, longitude: number): boolean {
  if (
    latitude === undefined || longitude === undefined ||
    latitude === null || longitude === null ||
    isNaN(Number(latitude)) || isNaN(Number(longitude)) ||
    Number(latitude) < MIN_LAT || Number(latitude) > MAX_LAT ||
    Number(longitude) < MIN_LNG || Number(longitude) > MAX_LNG
  ) {
    return false;
  }
  return true;
}